export enum MemberWorldGroup {
  bank_link = 'bank_link',
  bank_customers = 'bank_customers', // verimi login
  bank_members = 'bank_members',
  bank_employees = 'bank_employees',
  bank_representatives = 'bank_representatives',
}
